import React, { Fragment } from "react";
import Trivia from "./Trivia";
import Formulario from "./Formulario";
import Encuesta from "./Encuesta";

const Componentes = [Trivia, Formulario, Encuesta];

export default tipo =>
  Componentes.find(c => c.displayName === tipo) || (() => <Fragment />);
